import React, {useCallback, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Vendor} from 'pwm-shared';
import {useParams} from 'react-router-dom';
import PWMPageContainer from 'src/PWM/components/page/PWMPageContainer';
import {paths} from 'src/PWM/paths';
import {BreadcrumbData} from 'src/PWM/components/page/PWMBreadcrumbs';
import {useVendorApi} from 'src/PWM/pages/vendors/vendor.api';
import VendorInfoComponent from 'src/PWM/pages/vendors/components/VendorInfoComponent';
import {tokens} from 'src/PWM/locales/tokens';

const VendorAssignmentPage: React.FC<IVendorAssignmentPageProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [vendorInfo, setVendorInfo] = React.useState<Vendor.GetProjectVendorInfoResponse | undefined>();

  const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbData[]>([]);

  const {t} = useTranslation();
  const vendorApi = useVendorApi();
  const params = useParams();

  useEffect(() => {
    getVendorData();
  }, []);

  useEffect(() => {
    if (vendorInfo) {
      setBreadcrumbs([
        {
          href: paths.authenticated.home,
          name: t(tokens.nav.home)
        }, {
          href: `${paths.authenticated.contracts.index}/${vendorInfo.projectId}`,
          name: `${t(tokens.nav.contractdetail)}: ${vendorInfo.project.contractNumber} - ${vendorInfo.project.name}`
        }, {
          name: `${t(tokens.nav.vendorassignmentdetail)}`
        }]);
    }
  }, [vendorInfo]);

  const getVendorData = useCallback(async () => {
    if (vendorApi && params.assignmentId) {
      const {data} = await vendorApi.getVendorAssignment(params.assignmentId);
      setVendorInfo(data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      alert(JSON.stringify(params));
    }
  },[vendorApi, setVendorInfo, setIsLoading, params]);

  return (
    <PWMPageContainer
      isLoading={isLoading}
      title={t(tokens.nav.vendorassignmentdetail)}
      breadcrumbs={breadcrumbs}
    >
      <VendorInfoComponent data={vendorInfo!} setIsLoading={setIsLoading} refreshInfo={getVendorData}/>
    </PWMPageContainer>
  );
};

export default VendorAssignmentPage;

interface IVendorAssignmentPageProps {
  children?: React.ReactNode;
}